<template>
  <group-list> </group-list>
</template>
<script>
import GroupList from "../components/List";

export default {
  name: "location-view-dashboard",
  components: {
    GroupList
  },
  data() {
    return {
      locationCount: 0
    };
  }
};
</script>
